import { Avatar } from "@mui/material";

import { userInitials } from "utils/userInitials/userInitials";

const UserAvatar = ({
  userName = "N N",
  fontSize = 16,
  size = 60,
}: {
  userName: string;
  fontSize?: number;
  size?: number;
}) => {
  const generatedUserInitials = userInitials(userName);

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize,
        bgcolor: "primary.main",
        border: "1px solid #E8E8E8",
      }}
    >
      {generatedUserInitials.slice(0, 2)}
    </Avatar>
  );
};

export default UserAvatar;
